import { Colors } from 'enums';
import { DiscountRequestStatus } from 'interfaces';
import { t } from 'i18next';

export function getDiscountRequestStatusText(
  status: DiscountRequestStatus,
  isForHr: boolean,
) {
  const statusPrefix = isForHr ? 'hr' : 'employee';

  switch (status) {
    case DiscountRequestStatus.NEW:
      return t(`discountRequestsList.${statusPrefix}Status.new`);
    case DiscountRequestStatus.IN_PROGRESS:
      return t(`discountRequestsList.${statusPrefix}Status.in_progress`);
    case DiscountRequestStatus.DECLINED:
      return t(`discountRequestsList.${statusPrefix}Status.declined`);
    case DiscountRequestStatus.APPROVED:
      return t(`discountRequestsList.${statusPrefix}Status.approved`);
    default:
      return undefined;
  }
}

export function getDiscountRequestStatusColor(status: DiscountRequestStatus) {
  switch (status) {
    case DiscountRequestStatus.NEW:
      return Colors.yellow1;
    case DiscountRequestStatus.IN_PROGRESS:
      return Colors.green;
    case DiscountRequestStatus.DECLINED:
      return Colors.red3;
    case DiscountRequestStatus.APPROVED:
      return Colors.blue;
    default:
      return undefined;
  }
}

export function getDiscountRequestStatusNotificationMessage({
  status,
  formattedDate,
  companyName,
}: {
  status: DiscountRequestStatus;
  formattedDate: string;
  companyName?: string;
}) {
  const options = { name: companyName, date: formattedDate };

  switch (status) {
    case DiscountRequestStatus.IN_PROGRESS:
      return t(
        'serviceNotifications.discountRequest.message.in_progress',
        options,
      );
    case DiscountRequestStatus.DECLINED:
      return t(
        'serviceNotifications.discountRequest.message.declined',
        options,
      );
    case DiscountRequestStatus.APPROVED:
      return t(
        'serviceNotifications.discountRequest.message.approved',
        options,
      );
    default:
      return undefined;
  }
}
